import {
  AmericanGroupFormat,
  OverflowGroupClassification,
} from '@/types/tournament.model';
import type { OptionCard } from './OptionCardsField';

/**
 * Formato Corto: cuántos equipos clasifican cuando el fixture arma un grupo de 4.
 * Mapeado sobre `overflowGroupClassification`.
 */
export const OVERFLOW_CLASSIFICATION_OPTIONS: OptionCard<OverflowGroupClassification>[] =
  [
    {
      value: OverflowGroupClassification.STANDARD,
      label: '2 clasificados',
      description: 'Pasan 2 equipos por grupo, igual que en los grupos de 3.',
    },
    {
      value: OverflowGroupClassification.EXTRA_CLASSIFIER,
      label: '3 clasificados',
      description:
        'Si el fixture arma grupos de 4, clasifican 3 en lugar de 2.',
    },
  ];

/**
 * Americano (Padel): formato de los partidos dentro del grupo.
 * Mapeado sobre `americanGroupFormat`.
 */
export const AMERICAN_GROUP_FORMAT_OPTIONS: OptionCard<AmericanGroupFormat>[] = [
  {
    value: AmericanGroupFormat.WINNER_LOSER,
    label: 'Por resultado',
    description:
      '2 partidos iniciales y luego ganador vs ganador / perdedor vs perdedor (4 partidos).',
  },
  {
    value: AmericanGroupFormat.ROUND_ROBIN,
    label: 'Todos contra todos',
    description:
      'Round-robin completo: cada equipo juega contra todos (6 partidos).',
  },
];

/**
 * Americano (Squash/Tennis): mismo concepto que {@link AMERICAN_GROUP_FORMAT_OPTIONS}
 * pero mapeado sobre `overflowGroupClassification` (EXTRA_CLASSIFIER = por resultado).
 */
export const AMERICAN_OVERFLOW_FORMAT_OPTIONS: OptionCard<OverflowGroupClassification>[] =
  [
    {
      value: OverflowGroupClassification.EXTRA_CLASSIFIER,
      label: 'Por resultado',
      description:
        '2 partidos iniciales y luego según resultado (ganador vs ganador / perdedor vs perdedor).',
    },
    {
      value: OverflowGroupClassification.STANDARD,
      label: 'Todos contra todos',
      description: 'Round-robin completo: 6 partidos por grupo.',
    },
  ];
